import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-scales-details-dialog',
  templateUrl: './scales-details-dialog.component.html',
  styleUrls: ['./scales-details-dialog.component.scss']
})
export class ScalesDetailsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  getTranslateStatusToBR(status: string): string {
    switch (status.toLowerCase()) {
      case 'scheduled':
        return 'Agendado';
      case 'started':
        return 'Em andamento';
      case 'ended':
        return 'Encerrado';
      case 'no show':
        return 'Não compareceu';
      default:
        return 'Agendado';
    }
  }
}
